import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    offset: { type: Number, default: 300 }
  }

  connect() {
    this.toggleVisibility = this.toggleVisibility.bind(this)
    window.addEventListener("scroll", this.toggleVisibility)
    window.addEventListener("load", this.toggleVisibility)
  }

  disconnect() {
    window.removeEventListener("scroll", this.toggleVisibility)
    window.removeEventListener("load", this.toggleVisibility)
  }

  toggleVisibility() {
    // console.log(window.scrollY)
    if (window.scrollY > this.offsetValue) {
      this.element.classList.add("show")
    } else {
      this.element.classList.remove("show")
    }
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    })
  }
}
